import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';
import {StandardComponent} from "./modules/device-config/standard/standard.component";

export const routes: Routes = [
    {
        path: 'device-config',
        loadChildren: () => import('./modules/device-config/device-config.module').then(m => m.DeviceConfigModule),
        canActivate: [() => authGuard()]
    },
    // Main dashboard - protected by auth guard and permission guard
    {
        path: 'dashboard',
        loadComponent: () => import('./modules/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [() => permissionGuard()]
    },
    // Accounts search (converted from legacy printingDevicesList)
    {
        path: 'accounts/search',
        loadComponent: () => import('./modules/accounts/accounts-search/accounts-search.component').then(m => m.AccountsSearchComponent),
        canActivate: [() => authGuard()]
    },

    // Device routes
    {
        path: 'devices',
        loadComponent: () => import('./modules/devices/device-list/device-list.component').then(m => m.DeviceListComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'devices/add',
        loadComponent: () => import('./modules/devices/device-add/device-add.component').then(m => m.DeviceAddComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'devices/:id',
        loadComponent: () => import('./modules/devices/device-detail/device-detail.component').then(m => m.DeviceDetailComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'change-sim',
        loadComponent: () => import('./modules/devices/change-sim/change-sim.component').then(m => m.ChangeSimComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'generation-boxes',
        loadComponent: () => import('./modules/generation-boxes/generation-boxes.component').then(m => m.GenerationBoxesComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'generation-boxes-scan',
        loadComponent: () => import('./modules/generation-boxes/generation-boxes-scan.component').then(m => m.GenerationBoxesScanComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'migrationOfCardNumbers',
        loadComponent: () => import('./modules/migration-of-card-numbers/migration-of-card-numbers.component').then(m => m.MigrationOfCardNumbersComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'searchSim',
        loadComponent: () => import('./modules/search-sim/search-sim.component').then(m => m.SearchSimComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'sendPackage',
        loadComponent: () => import('./modules/send-package/send-package.component').then(m => m.SendPackageComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'fullFillment',
        loadComponent: () => import('./modules/send-package/send-package-fulfillment.component').then(m => m.SendPackageFulfillmentComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'configurePayments',
        loadComponent: () => import('./modules/configure-payments/configure-payments.component').then(m => m.ConfigurePaymentsComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'panel',
        loadComponent: () => import('./modules/main/panel/panel.component').then(m => m.PanelComponent),
        canActivate: [() => authGuard()]
    },

    // Google-only login route (public)
    {
        path: 'login',
        loadComponent: () => import('./modules/user/login/login.component').then(m => m.LoginComponent)
    },

    // Tools
    {
        path: 'tools/upload-csv',
        loadComponent: () => import('./modules/tools/upload-csv/upload-csv.component').then(m => m.UploadCsvComponent),
        canActivate: [() => authGuard()]
    },

    // Promo codes
    {
        path: 'promo-codes',
        loadComponent: () => import('./modules/promo-codes/promo-codes-list/promo-codes-list.component').then(m => m.PromoCodesListComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'promo-codes/add',
        loadComponent: () => import('./modules/promo-codes/promo-codes-add/promo-codes-add.component').then(m => m.PromoCodesAddComponent),
        canActivate: [() => authGuard()]
    },
    {
        path: 'device-config/standard',
        loadComponent: () => import('./modules/device-config/standard/standard.component').then(m => m.StandardComponent),
        canActivate: [() => authGuard()]
    },

    // Default routes
    { path: '', redirectTo: '/devices', pathMatch: 'full' },
    { path: '**', redirectTo: '/devices' }
];
